import { useEffect, useState } from 'react';
import { Modal, Form, Select, Input, Checkbox, Button, Spin } from 'antd';
import { toast } from 'react-toastify';
import {
    useStoreCategoryMutation,
    useGetCategoryListingMutation
} from "../slices/apiSlice";

const TransactionModal = ({
    isModalOpen,
    closeAndReset,
    linkData,
    properties,
    companyList,
    categoryData,
    handleFinish,
    isLoadingForm,
    isSaving,
    isSplitPayment,
    setIsSplitPayment,
    propertyAmounts,
    setPropertyAmounts,
    handleSplitPaymentChange,
    handleCompanyChange,
    handleDropdownVisibleChange,
    handleAddCompany,
    isLoadingAddCompany,
    ExpenseOptions,
    form,
    isLoadingAddExpense,
    selectedRowsData,
    categoryPlaidData,
    subCategoryData,
    selectedRowKeys
}) => {
    const [inputValue, setInputValue] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownCategoryVisible, setDropdownCategoryVisible] = useState(false);
    const [dropdownSubCategoryVisible, setDropdownSubCategoryVisible] = useState(false);
    const [inputCategoryValue, setInputCategoryValue] = useState("");
    const [loaderValue, setLoaderValue] = useState(false);
    const [subLoaderValue, setSubLoaderValue] = useState(false);
    const [storeCategory, { isLoading: categoryAddLoading }] = useStoreCategoryMutation();
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [inputSubCategoryValue, setInputSubCategoryValue] = useState(false);
    const [subCategoryDataList, setSubCategoryDataList] = useState(false);
    const [categories, setCategories] = useState(categoryData || []);
    const [getCategoryListing, { data }] = useGetCategoryListingMutation();

    useEffect(() => {
        setSubCategoryDataList(subCategoryData);
    }, []);

    const renderAmount = () => {
        let amount = 0;
        if (linkData && typeof linkData.amount === 'number') {
            amount = linkData.amount.toFixed(2);
        }
        return amount;
    };

    const handleAddCategory = async () => {
        setLoaderValue(true);
        showLoader();
        let res = await handleAddNewCategory(inputCategoryValue);
        form.setFieldsValue({
            category_id: res.name,
            sub_category_id: null
        });
        setSelectedCategoryId(res?.id);
        setDropdownCategoryVisible(false);
    }

    const handleAddNewCategory = async (value) => {
        let formData = {
            type: "category",
            category_name: value,
        }
        try {
            const response = await storeCategory(formData);
            if (response.data) {
                let data = response.data?.data;
                toast.success(response.data?.message);
                return data;
            } else {
                toast.error(`${response?.error?.data?.message}` || "Failed to add new Category!");
            }
        } catch (error) {
            toast.error("Failed to add new Category!");
        }
    }

    const handleAddSubCategory = async () => {
        setSubLoaderValue(true);
        showsubLoader();
        let res = await handleAddNewSubCategory(inputSubCategoryValue);
        let findSelectedSubCat = res?.find((item) => item?.sub_category_name === inputSubCategoryValue);
        form.setFieldsValue({
            sub_category_id: findSelectedSubCat?.sub_category_name
        });
        let transformData = res.map((item) => ({
            name: item?.sub_category_name,
            id: item?.sub_category_id
        }));
        setSubCategoryDataList(transformData);
        setSelectedSubCategoryId(findSelectedSubCat?.sub_category_id);
        setDropdownSubCategoryVisible(false);
    }

    const handleAddNewSubCategory = async (value) => {
        let formData = {
            type: "sub_category",
            category_id: selectedCategoryId !== null ? selectedCategoryId : categoryPlaidData?.category_id,
            sub_category_name: value
        }
        try {
            const response = await storeCategory(formData);
            if (response.data) {
                let data = response.data?.data;
                toast.success(response.data?.message);
                return data;
            } else {
                toast.error(`${response?.error?.data?.error}` || "Failed to add new Sub-Category!");
            }
        } catch (error) {
            toast.error("Failed to add new Sub-Category!");
        }
    }

    const showLoader = () => {
        setTimeout(() => {
            setLoaderValue(false);
        }, 2000);
    }

    const showsubLoader = () => {
        setTimeout(() => {
            setSubLoaderValue(false);
        }, 2000);
    }

    const handleFormSubmit = (data) => {
        data.category_id = selectedCategoryId !== null ? selectedCategoryId : categoryPlaidData.category_id;
        data.sub_category_id = selectedSubCategoryId !== null ? selectedSubCategoryId : categoryPlaidData.id;
        handleFinish(data);
    }

    const handleCategorySearch = async (value) => {
        setInputCategoryValue(value);
        if (value) {
            try {
                const response = await getCategoryListing({ search_term: value }).unwrap();
                setCategories(response?.categories || []);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        }
    }

    const handleCategorySelect = (data) => {
        setDropdownCategoryVisible(false);
        setSelectedCategoryId(data.value);
        let findSubCat = categories?.find((item) => item.category_id === data.value);
        if (findSubCat) {
            setSubCategoryDataList(findSubCat?.sub_categories);
        }
    }

    const handleSelectSubCategory = (data) => {
        setSelectedSubCategoryId(data?.value);
    }

    return (
        <Modal
            className="deleteModal addTransCustomModal"
            open={isModalOpen}
            onCancel={closeAndReset}
            footer={false}
            title={
                <>
                    {selectedRowKeys?.length === 0 ? (
                        <>
                        Add your Expense
                        <div style={{ marginTop: '8px', fontWeight: 700, width: 'fit-content', fontSize: '1rem' }}>
                            ${renderAmount()}
                        </div>
                        </>
                    ) : (
                        <>
                        Add your transactions
                        </>
                    )}
                </>
            }
        >
            {selectedRowKeys?.length === 0 && (
                <p className="transaction-name">Transaction Name - {linkData?.name}</p>
            )}

            <div className="modal-body">
                {isLoadingForm ? (
                    <Spin style={{ display: "flex", justifyContent: "center", margin: "20px 0" }} />
                ) : (
                    <>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={(values) => {
                                const totalSplitAmount = Math.abs(
                                    Object.values(propertyAmounts)
                                        .reduce((sum, amount) => sum + (parseFloat(amount) || 0), 0)
                                ).toFixed(2);

                                const actualAmount = Math.abs(linkData?.amount || 0).toFixed(2);

                                if (isSplitPayment && parseFloat(totalSplitAmount) !== parseFloat(actualAmount)) {
                                    toast.error(`The total split payment ($${totalSplitAmount}) must match the actual amount ($${actualAmount}).`);
                                    return;
                                }

                                const finalValues = {
                                    ...values,
                                    propertyAmounts,
                                };
                                handleFormSubmit(finalValues);
                                setIsSplitPayment(false);
                            }}
                            initialValues={{
                                properties: [],
                                splitPayment: false,
                                future_add: false,
                            }}
                            className="transactionForm"
                        >
                            {selectedRowKeys?.length === 0 && (
                                <>
                                    <div className="accountNumberWrapper">
                                        <Form.Item
                                            label="Card / Account No."
                                            name="mask"
                                        >
                                            <Input disabled className="form-control" />
                                        </Form.Item>
                                    </div>
                                    <div className="accountNumberWrapper">
                                        <Form.Item
                                            label="Billing Descriptor"
                                            name="billing_descriptor"
                                        >
                                            <Input disabled className="form-control" />
                                        </Form.Item>
                                    </div>
                                </>
                            )}

                            <div className="textRow me-2">
                                {!isSplitPayment ? (
                                    <Form.Item
                                        label="Property Name"
                                        className="firstFormItem"
                                        name="properties"
                                        rules={[{ required: true, message: "Please select at least one property." }]}
                                    >
                                        <Select
                                            className="formControl select-custom"
                                            style={{ width: "100%" }}
                                            placeholder="Select property"
                                            labelInValue
                                            options={properties}
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                        />
                                    </Form.Item>
                                ) : (
                                    <div className="splitRow">
                                        {properties.map((property) => (
                                            <div className="splitCol" key={property.value}>
                                                <Form.Item label={
                                                    <span style={{
                                                        display: "inline-block",
                                                        maxWidth: "200px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    }}>
                                                        {property.label}
                                                    </span>
                                                } style={{ marginBottom: '16px' }}>
                                                    <Input
                                                        type="number"
                                                        value={propertyAmounts[property.value] || ''}
                                                        onChange={(e) => {
                                                            setPropertyAmounts({
                                                                ...propertyAmounts,
                                                                [property.value]: e.target.value,
                                                            })
                                                        }}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9.]/.test(e.key) || (e.key === '.' && e.target.value.includes('.'))) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onPaste={(e) => {
                                                            const paste = (e.clipboardData || window.clipboardData).getData("text");
                                                            if (!/^\d*\.?\d*$/.test(paste)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        placeholder={`Amount for ${property.label}`}
                                                    />
                                                </Form.Item>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="splitPaymentButton mt-2">
                                    <Checkbox onChange={handleSplitPaymentChange} checked={isSplitPayment ? true : false}>Split Payment</Checkbox>
                                </div>

                                <div className="companyWrapper">
                                    <Form.Item
                                        label="Company Name"
                                        name="company_id"
                                        rules={[{ required: true, message: "Please select a company." }]}
                                    >
                                        <Select
                                            className="formControl select-custom"
                                            style={{ width: "100%" }}
                                            placeholder="Select a company"
                                            labelInValue
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                            onSearch={(value) => setInputValue(value)}
                                            onChange={(value) => {
                                                handleCompanyChange(value);
                                                setDropdownOpen(false);
                                            }}
                                            options={companyList?.map((item) => ({
                                                label: item.name,
                                                value: item.id,
                                            }))}
                                            open={dropdownOpen}
                                            notFoundContent={
                                                companyList?.length === 0 || !inputValue
                                                    ? null
                                                    : "No matching records found!"
                                            }
                                            onDropdownVisibleChange={(visible) => setDropdownOpen(visible)}
                                            optionRender={(option) => (
                                                <span role="img" aria-label={option.label}>
                                                    {option.label}
                                                </span>
                                            )}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    const matchedOption = companyList.find(
                                                        (opt) => opt.name.toLowerCase() === inputValue.toLowerCase()
                                                    );
                                                    if (matchedOption === undefined && inputValue !== "") {
                                                        handleAddCompany(inputValue);
                                                    }
                                                }
                                            }}
                                            dropdownRender={(menu) => (
                                                <>
                                                    {menu}
                                                    {inputValue && !companyList?.some((opt) => opt.name.toLowerCase() === inputValue.toLowerCase()) && (
                                                        <div style={{ display: "flex", justifyContent: "space-between", padding: 8 }}>
                                                            <span>Add "{inputValue}"</span>
                                                            <Button type="link" onClick={() => handleAddCompany(inputValue)} disabled={isLoadingAddCompany}>
                                                                {isLoadingAddCompany ? <Spin size="small" /> : "Add"}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        />
                                    </Form.Item>
                                </div>

                                {/* Category */}
                                <div className="serviceWrapper" style={{ position: 'relative' }}>
                                    {loaderValue ? (
                                        <div className="ownerLoaderWrapper">
                                            <Spin />
                                        </div>
                                    ) : ('')}
                                    <Form.Item
                                        label="Category Name"
                                        name="category_id"
                                        rules={[{ required: true, message: "Please select a category." }]}
                                    >
                                        <Select
                                            open={dropdownCategoryVisible}
                                            onDropdownVisibleChange={(visible) => setDropdownCategoryVisible(visible)}
                                            className="formControl select-custom"
                                            style={{ width: "100%" }}
                                            optionLabelProp="label"
                                            placeholder="Start Typing to Search Category"
                                            labelInValue
                                            showSearch
                                            loading={categoryAddLoading}
                                            // disabled={categoryAddLoading}
                                            onSelect={(value) => handleCategorySelect(value)}
                                            onSearch={(value) => handleCategorySearch(value)}
                                            filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={categories?.map((item) => ({
                                                label: item.category_name,
                                                value: item.category_id,
                                            }))}
                                            optionRender={(option) => (
                                                <span role="img" aria-label={option.label}>
                                                    {option.label}
                                                </span>
                                            )}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    const matchedOption = categories.find(
                                                        (opt) => opt.category_name.toLowerCase() === inputCategoryValue.toLowerCase()
                                                    );
                                                    if (matchedOption === undefined && inputCategoryValue !== "") {
                                                        handleAddCategory();
                                                    }
                                                }
                                            }}
                                            notFoundContent={
                                                categories.length === 0 && inputCategoryValue === ""
                                                    ? null
                                                    : "No matching records found!"
                                            }
                                            dropdownRender={(menu) => (
                                                <>
                                                    {menu}
                                                    {inputCategoryValue &&
                                                        !categories.some((opt) => opt.category_name.toLowerCase() === inputCategoryValue.toLowerCase()) && (
                                                            <div style={{ display: "flex", justifyContent: "space-between", padding: 8 }}>
                                                                <span>Add "{inputCategoryValue}"</span>
                                                                <Button type="link" onClick={handleAddCategory} disabled={categoryAddLoading}>
                                                                    {categoryAddLoading ? <Spin size="small" /> : "Add"}
                                                                </Button>
                                                            </div>
                                                        )}
                                                </>
                                            )}
                                        />
                                    </Form.Item>
                                </div>

                                {/* Sub-Category */}
                                <div className="serviceWrapper" style={{ position: 'relative' }}>
                                    {subLoaderValue ? (
                                        <div className="ownerLoaderWrapper">
                                            <Spin />
                                        </div>
                                    ) : ('')}
                                    <Form.Item
                                        label="Sub-Category Name"
                                        name="sub_category_id"
                                        rules={[{ required: true, message: "Please select a Sub-Category" }]}
                                    >
                                        <Select
                                            open={dropdownSubCategoryVisible}
                                            onDropdownVisibleChange={(visible) => setDropdownSubCategoryVisible(visible)}
                                            className="formControl select-custom"
                                            style={{ width: "100%" }}
                                            optionLabelProp="label"
                                            placeholder="Start Typing to create new sub-category"
                                            labelInValue
                                            showSearch
                                            loading={categoryAddLoading}
                                            onSelect={(value) => handleSelectSubCategory(value)}
                                            onSearch={(value) => setInputSubCategoryValue(value)}
                                            filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={(subCategoryDataList || []).map((item) => ({
                                                label: item.name,
                                                value: item.id,
                                            }))}
                                            optionRender={(option) => (
                                                <span role="img" aria-label={option.label}>
                                                    {option.label}
                                                </span>
                                            )}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    const matchedOption = (subCategoryDataList || []).find(
                                                        (opt) => opt.name.toLowerCase() === inputSubCategoryValue.toLowerCase()
                                                    );
                                                    if (matchedOption === undefined && inputSubCategoryValue !== "") {
                                                        handleAddSubCategory();
                                                    }
                                                }
                                            }}
                                            notFoundContent={
                                                (subCategoryDataList?.length === 0 && inputSubCategoryValue === "")
                                                    ? null
                                                    : "No matching records found!"
                                            }
                                            dropdownRender={(menu) => (
                                                <>
                                                    {menu}
                                                    {inputSubCategoryValue &&
                                                        !(subCategoryDataList || []).some(
                                                            (opt) => opt.name.toLowerCase() === inputSubCategoryValue.toLowerCase()
                                                        ) && (
                                                            <div style={{ display: "flex", justifyContent: "space-between", padding: 8 }}>
                                                                <span>Add "{inputSubCategoryValue}"</span>
                                                                <Button type="link" onClick={handleAddSubCategory} disabled={categoryAddLoading}>
                                                                    {categoryAddLoading ? <Spin size="small" /> : "Add"}
                                                                </Button>
                                                            </div>
                                                        )}
                                                </>
                                            )}
                                        />

                                    </Form.Item>


                                </div>

                                {/* Auto Linked */}
                                <div className="checkboxWrapper">
                                    <Form.Item
                                        name="future_add"
                                        valuePropName="checked"
                                        className="customCheckbox"
                                    >
                                        <Checkbox>
                                            Do you want all future transactions to be auto-linked with this billing descriptor?
                                        </Checkbox>
                                    </Form.Item>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="authBtn" disabled={isSaving} loading={isLoadingAddExpense || isLoadingAddCompany}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default TransactionModal; 